let state = {

  // 个人信息
  userInfo: {},
}

export default state
